angular.module('cfn').directive('cfnInputDatetime', function() {
  return {
    restrict: 'E',
    scope: {
      model: '=',
      afterLink: '=',
      beforeLink: '=',
      class: '@',
      spanDate: '@',
      spanTime: '@',
      readonly: '=',
      required: '@',
      change: '&'
    },
    replace: true,
    template:
      '<span>' +
      '<span class="{{spanDate?spanDate:\'span3\'}}" style="margin-left:0px;">' +
      '<cfn-input-date model="date" after-link="afterLink" before-link="beforeLink" class="{{class}}" readonly="readonly" required="{{required}}" change="onChange()"> ' +
      '</cfn-input-date>' +
      '</span>' +
      '<span class="{{spanTime?spanTime:\'span2\'}}">' +
      '<cfn-input-time timemodel="time"  class="{{class}}" readonly="readonly" required="{{required}}" change="onTimeChange()"> ' +
      '</cfn-input-time>' +
      '</span>' +
      '</span>',
    link: function(scope, element, attr, ngModel) {
      scope.date = null;
      scope.time = null;
      scope.onTimeChange = function() {};
      scope.onChange = function() {
        scope.change();
      };

      let skipChange = false;
      let skipDateChange = false;
      let skipTimeChange = false;

      scope.$watch('model', function() {
        if (skipChange) {
          skipChange = false;
          return;
        }
        skipTimeChange = true;
        skipDateChange = true;
        if (scope.model) {
          scope.date = new Date(scope.model);
        } else {
          scope.date = null;
        }

        if (!scope.model) {
          scope.time = null;
        } else {
          let minutes = scope.date.getMinutes();
          let hour = scope.date.getHours();
          if (minutes < 10) {
            minutes = '0' + minutes;
          }
          if (hour < 10) {
            hour = '0' + hour;
          }
          scope.time = hour + ':' + minutes;
        }
        skipTimeChange = false;
      });

      let updateModel = function() {
        skipChange = true;
        scope.model = combineDate();
      };

      let combineDate = function() {
        let date = new Date(scope.date);
        if (scope.time && scope.time.indexOf(':') != -1) {
          let time = scope.time.split(':');
          if (time.length > 1) {
            date.setHours(time[0]);
            date.setMinutes(time[1]);
          }
        }
        return date.getTime();
      };
      scope.$watch('date', function() {
        if (!skipDateChange) {
          updateModel();
        }
        skipDateChange = false;
      });
      scope.$watch('time', function() {
        if (!skipTimeChange) {
          updateModel();
        }
        skipTimeChange = false;
      });
    }
  };
});
